import { ApolloQueryResult } from '@apollo/client';
import React from 'react';
import { EnumGenericJobStatus, FetchUserQuery, TaxMethod } from '../graphql/types';
import Auth from '../lib/Auth';

type FetchedUser = NonNullable<FetchUserQuery['user']>;

export type User = Omit<FetchedUser, '__typename'> | null;

interface UserContextType {
  isHijacked?: boolean;
  isTokenTaxAdmin: boolean;
  isTokenTaxDev?: boolean;
  refetch?: () => Promise<ApolloQueryResult<FetchUserQuery>>;
  //user is the user that is actually being controlled if you are hijacked it will be the hijacked user
  user?: User;
  userLoading?: boolean;
  isLoggedIn?: boolean;
  taxMethods?: TaxMethod[];
  roles?: string[];
  currentUserRole?: string;
  txnEditingIsLocked?: boolean;
  latestBatchUpdateTxnsJobStatus?: EnumGenericJobStatus | null;
  setPollLatestBatchUpdateJobStatus?: (poll: boolean) => void;
  latestBatchDeleteTxnsJobStatus?: EnumGenericJobStatus | null;
  setPollLatestBatchDeleteJobStatus?: (poll: boolean) => void;
  highestPlan?: string;
  organizationId?: number | null;
  stripeCustomerId?: string | null;
}

export const UserContext = React.createContext<UserContextType>({
  isTokenTaxAdmin: Auth.tokenIsForAdmin(),
  isTokenTaxDev: Auth.tokenIsForDev(),
  userLoading: false,
});
UserContext.displayName = 'UserContext';

export const useUserContext = () => React.useContext(UserContext);
